import type { FC } from "react";

import { usePageTitle } from "utils/hooks/usePageTitle";

interface Props {
  customTitle?: string;
  className?: string;
}

const PageHeading: FC<Props> = ({ className, customTitle }) => {
  const { titleParts } = usePageTitle(customTitle);
  const parts = customTitle !== undefined ? [customTitle, ...titleParts] : titleParts;

  const [title, ...subtitles] = parts;
  return (
    <h1 className={className}>
      {title}
      {subtitles.length > 0 && <span className="subheading"> / {subtitles.join(" / ")}</span>}
    </h1>
  );
};

export default PageHeading;
